<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn width-auto btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="ADD" />
        </div>
      </div>
      <Dialogs header="Customer Account" position="center" :visible.sync="addDisplayBasic"
               :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'overlay'}">

        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Name<span style="color:red">*</span></label>
            <InputText id="name" v-model.trim="name"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="shortName">Short Name</label>
            <InputText v-model.trim="shortName" id="shortName"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="contactPerson">Contact Person</label>
            <InputText v-model.trim="contactPerson" id="contactPerson"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="tel">Tel-phone</label>
            <InputText @keypress="isNumber($event)" v-model.trim="telcontact" id="tel"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="contactNum">Contact Number</label>
            <InputText @keypress="isNumber($event)" v-model="contactNumber" id="contactNum"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="sec">Seconday Contact</label>
            <InputText @keypress="isNumber($event)" v-model="secondaryContact" id="secNo"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="accountContactPerson">Account Contact Name</label>
            <InputText v-model.trim="accountContactPerson" id="accountContactPerson"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="accountContactNumber">Account Person Number</label>
            <InputText @keypress="isNumber($event)" v-model="accountContactNumber" id="accountContactNumber"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="email">Email</label>
            <InputText v-model.trim="email" id="email"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="address">Address</label>
            <InputText v-model.trim="address" id="address"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="openingBalance">Opening Balance</label>
            <InputText type="text" @keypress="isNumber($event)" v-model.number="openingBalance" id="openingBalance"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="accountType">Dr/Cr Type</label>
            <select class="selectBox" v-model="openingDrCr">
              <option selected disabled value="">Select Dr/Cr</option>
              <option v-for="(drcr,ind) in dr_crList" :key="ind">{{ drcr.openingDrCr }}</option>
            </select>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="panNo">Pan/Vat No</label>
            <InputText @keypress="isNumber($event)" v-model.number="panNo" id="panNo"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="">Status</label>
            <div class="radiobox">
              <div class="radiobox-itm">
                <RadioButton id="status1" name="ACTIVE" value="ACTIVE" v-model="status"/>
                <label for="status1">Active</label>
              </div>
              <div class="radiobox-itm">
                <RadioButton id="status2" name="INACTIVE" value="INACTIVE" v-model="status"/>
                <label for="status2">Inactive</label>
              </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="followUpDays">Follow Up Days</label>
            <InputText v-model.trim="followUpDays" id="followUpDays"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="creditDays">Credit Days</label>
            <InputText v-model.trim="creditDays" id="creditDays"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="creditLimit">Credit Limit</label>
            <InputText v-model.trim="creditLimit" id="creditLimit"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
          <label for="customerType">Customer Type<span style="color:red">*</span></label>
          <Dropdown 
            v-model="customerType" 
            :options="customerTypes" 
            optionLabel="label" 
            placeholder="Select Customer Type" 
            :filter="true" 
            :showClear="true"
            id="customerType"
          />
        </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="head">Child Sub Group<span style="color:red"></span></label>
            <!-- <Dropdown v-if="!systemOnly" v-model="accountHeadId" :options="accountHeadLists" optionLabel="name" placeholder="Select Account Group" :filter="true" :showClear="true"/> -->
            <Dropdown v-model="accountHeadId" :options="accountHeadLists" optionLabel="name"
                      placeholder="Select Child Group" :filter="true" :showClear="true"/>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised" @click.prevent="addAccountMaster"
                  :label="editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-info" @click.prevent="addAndNewAccountMaster"
                  v-if="!editing" label="Add & New"/>
          <Button @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'

export default {
  name: 'customer',
  data() {
    return {
      name: '',
      contactNumber: '',
      address: '',
      shortName: '',
      contactPerson: '',
      accountContactPerson: '',
      accountContactNumber: '',
      telcontact: '',
      secondaryContact: '',
      email: '',
      dateOfBirth: '',
      openingBalance: '',
      panNo: '',
      openingDrCr: 'Dr',
      status: 'ACTIVE',
      message: '',
      messageType: '',
      accountMaster: {},
      show: false,
      addDisplayBasic: false,
      editing: false,
      displayBasic: false,
      dialogShow: false,
      accountDetailId: '',
      position: 'center',
      accountId: '',
      dr_crList: [
        {'openingDrCr': 'Dr'},
        {'openingDrCr': 'Cr'}
      ],
      id: '',
      loading: false,
      columnList: '',
      filters: {},
      creditDays: 0,
      followUpDays: 0,
      creditLimit: 0,
      accountHeadId: '',
      accountSubHeadId: 0,
      customerType: null,
      customerTypes: [
        { label: 'Hospital/pharmacy', value: 'Hospital/pharmacy' },
        { label: 'Restaurant', value: 'Restaurant' },
        { label: 'Oil And Gas', value: 'Oil And Gas' },
        { label: 'Mart', value: 'Mart' },
        { label: 'Khanepani', value: 'Khanepani' },
        { label: 'Suppliers', value: 'Suppliers' },
        { label: 'Cinemas', value: 'Cinemas' },
        { label: 'Other', value: 'Other' }
      ]
    }
  },
  computed: {
    accountHeadLists() {
      return this.$store.state.accountHead.accountSubHeadDropList
    }
  },
  mounted() {
    this.accountHeadList()
  },
  methods: {
    async addAccountMaster() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Account Name cannot be empty!', life: 10000})
        return
      }
      if (!this.customerType) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Customer Type is required!', life: 10000})
        return
      }
      if (this.accountHeadId === null) {
        this.accountSubHeadId = 0
      } else {
        this.accountSubHeadId = this.accountHeadId.id
      }
      let accountMaster = {
        name: this.name,
        shortName: this.shortName,
        customerType: this.customerType.value,
        primaryContactNumber: this.contactNumber,
        secondaryContactNumber: this.secondaryContact,
        telContact: this.telcontact,
        address: this.address,
        email: this.email,
        dateOfBirthNepali: this.dateOfBirth,
        contactName: this.contactPerson,
        accountContactPerson: this.accountContactPerson,
        accountContactNumber: this.accountContactNumber,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        id: this.id,
        accountDetailId: this.accountDetailId,
        panNo: this.panNo,
        status: this.status,
        creditDays: this.creditDays,
        followUpDays: this.followUpDays,
        creditLimit: this.creditLimit,
        accountChildSubHeadId: this.accountSubHeadId
      }
      let resp = ''
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCustomerAccount', accountMaster)
        this.$emit('set_customer_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCustomerAccount', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewAccountMaster() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Account Name cannot be empty!', life: 10000})
        return
      }
      if (!this.customerType) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Customer Type is required!', life: 10000})
        return
      }
      if (this.accountHeadId === null) {
        this.accountSubHeadId = 0
      } else {
        this.accountSubHeadId = this.accountHeadId.id
      }
      let resp = ''
      let accountMaster = {
        name: this.name,
        customerType: this.customerType.value,
        shortName: this.shortName,
        primaryContactNumber: this.contactNumber,
        secondaryContactNumber: this.secondaryContact,
        telContact: this.telcontact,
        address: this.address,
        email: this.email,
        dateOfBirthNepali: this.dateOfBirth,
        contactName: this.contactPerson,
        accountContactPerson: this.accountContactPerson,
        accountContactNumber: this.accountContactNumber,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        id: this.id,
        accountDetailId: this.accountDetailId,
        panNo: this.panNo,
        status: this.status,
        creditDays: this.creditDays,
        followUpDays: this.followUpDays,
        creditLimit: this.creditLimit,
        accountChildSubHeadId: this.accountSubHeadId
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCustomerAccount', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.$emit('set_customer_master', resp.data.data)
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    async accountHeadList() {
      try {
        await this.$store.dispatch('accountSubHeadDropDown')
      } catch (e) {
        this.$toast.add({severity: 'success', summary: '', detail: 'Something went wrong!!', life: 10000})
      }
    },
    editCustomer(data) {
      this.addDialog = !this.addDialog
      this.id = data.id
      this.editing = true
      this.name = data.name
      this.shortName = data.shortName
      this.address = data.address
      this.telcontact = data.telContact
      this.dateOfBirth = data.dateOfBirthEnglish
      this.contactNumber = data.primaryContactNumber
      this.email = data.email
      this.contactPerson = data.contactName
      this.accountContactPerson = data.accountContactPerson
      this.accountContactNumber = data.accountContactNumber
      this.panNo = data.panNo
      this.accountDetailId = data.accountDetailId
      this.openingBalance = data.openingBalance
      this.status = data.status
      this.openingDrCr = data.openingDrCr
      this.creditDays = data.creditDays
      this.followUpDays = data.followUpDays
      this.creditLimit = data.creditLimit
      if (this.status === undefined) {
        this.status = 'INACTIVE'
      }
      if (data.customerType) {
        this.customerType = this.customerTypes.find(
          type => type.value === data.customerType
        )
      }
      this.openAddDialog()
    },
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteAccMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
        this.closeDialog()
      }
    },
    addCancel() {
      this.error = false
      this.message = ''
      this.messageType = ''
      this.reset()
      this.closeAddDialog()
    },
    reset() {
      this.editing = false
      this.name = ''
      this.email = ''
      this.customerType = null
      this.address = ''
      this.contactNumber = ''
      this.shortName = ''
      this.telcontact = ''
      this.openingBalance = ''
      this.drCr = ''
      this.openingDrCr = ''
      this.secondaryContact = ''
      this.contactPerson = ''
      this.accountContactPerson = ''
      this.accountContactNumber = ''
      this.panNo = ''
      this.creditDays = 0
      this.followUpDays = 0
      this.creditLimit = 0
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    Dropdown,
    Dialogs,
    InputText,
    RadioButton,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// CustomerAccountDialog.vue?0b482562